module.exports = __webpack_public_path__ + "static/media/lists.e9f735be.svg";